<template>
  <HeadingBox :title="tit" :description="descr" v-if="tit && descr" role="alert" aria-atomic="true"/>
</template>

<script>
import Session from "@/session/Session.js";
import HeadingBox from "@/components/HeadingBox";

export default {
  name: "AlertaError",
  components: {
    HeadingBox
  },
  props: {
    titulo: String,
    descripcion: String
  },
  data: () => ({
    tipo: 'danger',
    Session
  }),
  computed: {
    tit () {
      if(this.titulo) return this.titulo
      return Session.store.state.error.titulo
    },
    descr () {
      if(this.descripcion) return this.descripcion
      return Session.store.state.error.descripcion
    }
  }
};
</script>

<style scoped>

</style>

